import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: "Granular BRK";
        src: url("/fonts/granular.ttf") format("truetype");
        font-style: normal;
        font-display: swap;
    }

    body,
    html,
    a {
        font-family: 'Motiva Sans Light', sans-serif;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background-color: rgba(10.0,5.0,20.0,1.0);        
        overflow-x: hidden;
    }

    a:hover {
        color: #18216d;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;
        color: rgba(255.0,255.0,255.0,1.0)

        :focus-within {
            background: none;
            box-shadow: #2e186a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Motiva Sans Bold', serif;
        color: rgba(195.0,255.0,255.0,1.0);
        font-size: 56px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p {
        color: rgba(225.0,225.0,255.0,1.0);
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: rgba(225.0,225.0,255.0,1.0);

        :hover {
            color: rgba(195.0,255.0,255.0,1.0);
        }
    }
    
    *:focus {
        outline: none;
    }

    /* Ensure anchor scroll targets account for sticky header */
    [id] {
        scroll-margin-top: 6rem;

        @media only screen and (max-width: 1024px) {
            scroll-margin-top: 5rem;
        }

        @media only screen and (max-width: 768px) {
            scroll-margin-top: 4rem;
        }
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }

    /* Labels like Username, PW*/
    .ant-form-item-label label{
    margin-bottom: 0px;
    color: rgba(255.0,255.0,255.0,1.0);
  }
`;
